import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import type { ApiError } from 'core/config/request'

export type Fetcher<Response> = () => Response | Promise<Response>
export type UseRequestOptions<Response, Select = Response> = UseQueryOptions<
  Response,
  ApiError,
  Select
>

const useRequest = <Response, Select = Response>(
  key: [string, ...string[]],
  fetcher: Fetcher<Response>,
  options?: UseRequestOptions<Response, Select>
) => {
  return useQuery<Response, ApiError, Select>(key, fetcher, { ...options })
}

export default useRequest
